module.exports = __webpack_public_path__ + "static/media/card5_9.14530681.png";